import NewsBackgroundGrey from '../../../app/images/news-background-grey.png'
import NewsBackgroundSkyBlue from '../../../app/images/news-background-skyblue.png'

export const chooseNewImage = (index) => {
  return [0, 3].includes(index)
    ? NewsBackgroundSkyBlue
    : NewsBackgroundGrey
}
